<template>
  <div class="countdown-wrapper">
    <div class="hours-wrapper">
      <div class="display-box hour">{{ timerHour }}</div>
      <div class="label">
        {{ $t('Hrs') }}
      </div>
    </div>
    <div class="min-wrapper">
      <div class="display-box min">{{ timerMinite }}</div>
      <div class="label">
        {{ $t('Min') }}
      </div>
    </div>
    <div class="sec-wrapper">
      <div class="display-box sec">{{ timerSecond }}</div>
      <div class="label">
        {{ $t('Sec') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    timerHour: {
      type: String,
      default: '00',
    },
    timerMinite: {
      type: String,
      default: '00',
    },
    timerSecond: {
      type: String,
      default: '00',
    },
  },
};
</script>
<style lang="scss" scoped>
.countdown-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 14px;

    .display-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 32px;
      border-radius: 4px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
      background-color: #fff;
      font-size: 18px;
      font-weight: 600;
      color: #24475c;
      margin-bottom: 4px;
      position: relative;

      &:before {
        content: ':';
        color: #fff;
        position: absolute;
        right: -10px;
      }
    }

    &:last-of-type {
      margin-right: 0;
      .display-box:before {
        content: '';
      }
    }

    .label {
      font-size: 9px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      text-transform: uppercase;
    }
  }
}
</style>
